import snsAxiosClient from '../common/http/http-sns';
import formatString from '../utils/formatString';
import { get } from 'lodash';

function updateNextOrderSlots(environmentVariables, user, slotsInfo) {
  const options = {
    headers: {
      ...get(environmentVariables, 'API_HEADERS_PATCH_V1'),
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };

  return snsAxiosClient(options).patch(
    formatString(get(environmentVariables, 'SNS_NEXT_ORDER_SLOTS_UPDATE', 'update_next_order_slots'), {
      UUID: user.UUID,
    }),
    slotsInfo,
  );
}

export default updateNextOrderSlots;
